import React, { useState } from 'react'
import { AnimatePresence } from 'framer-motion'
import LegalModal from './LegalModal'

const LOGO_URL = 'https://customer-assets-jai6qajn.emergentagent.net/job_be6b6d40-04a2-4626-96b0-39ae7bcf5dea/artifacts/wk1w9zwb_logo.jpg'

export default function Footer() {
  const year = new Date().getFullYear()
  const [legalType, setLegalType] = useState(null)

  const legalLinks = [
    { label: 'Aviso legal', type: 'legal' },
    { label: 'Privacidad', type: 'privacidad' },
    { label: 'Cookies', type: 'cookies' },
  ]

  return (
    <>
      <footer className="bg-black border-t border-neutral-900 py-10 px-6 md:px-12 xl:px-16">
        <div className="max-w-screen-xl mx-auto">
          {/* Top row */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 mb-6">
            <div className="flex items-center gap-3">
              <img src={LOGO_URL} alt="JO." className="h-7 w-7 object-contain opacity-60" />
              <span className="text-white/30 text-xs tracking-[0.2em] uppercase"
                style={{ fontFamily: 'JetBrains Mono, monospace' }}>
                José Osuna · Diseñador Web · {year}
              </span>
            </div>
            <div className="flex items-center gap-6">
              <a href="https://wa.me/34633015650" target="_blank" rel="noopener noreferrer"
                className="text-white/25 hover:text-amber-400 transition-colors duration-300 text-xs tracking-[0.2em] uppercase"
                style={{ fontFamily: 'JetBrains Mono, monospace' }}>
                WhatsApp
              </a>
              <a href="https://www.jose-osuna.com" target="_blank" rel="noopener noreferrer"
                className="text-white/25 hover:text-amber-400 transition-colors duration-300 text-xs tracking-[0.2em] uppercase"
                style={{ fontFamily: 'JetBrains Mono, monospace' }}>
                jose-osuna.com ↗
              </a>
            </div>
          </div>

          {/* Legal links */}
          <div className="border-t border-neutral-900 pt-5 flex flex-wrap gap-6">
            {legalLinks.map((l) => (
              <button
                key={l.type}
                onClick={() => setLegalType(l.type)}
                data-testid={`footer-legal-${l.type}`}
                className="text-white/20 hover:text-amber-400 transition-colors duration-300 text-xs tracking-[0.2em] uppercase bg-transparent border-0"
                style={{ fontFamily: 'JetBrains Mono, monospace' }}
              >
                {l.label}
              </button>
            ))}
          </div>
        </div>
      </footer>

      <AnimatePresence>
        {legalType && <LegalModal type={legalType} onClose={() => setLegalType(null)} />}
      </AnimatePresence>
    </>
  )
}
